var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallOrangeTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.183 0L8.684 12.401 3.816 7.6 0 11.335 8.684 20 25 3.733z",
    fill: "#EE4900",
    fillRule: "evenodd"
  })));
}
export default SvgSmallOrangeTick;